<div
  class="form-group position-relative"
  [attr.data-cy]="id() + 'FormGroup'"
  [class.form-error-highlight]="invalid() === true || !(formControl.value | formControlValid: formControl)">
  @if (title(); as title) {
    <label class="label" [for]="id()" [attr.data-cy]="id() + 'Label'">
      {{ title | translate }}
    </label>
  }
  <div
    class="input-group {{ size() ? 'input-group-' + size() : '' }}"
    [class.disabled]="isDisabled"
    [attr.data-cy]="id() + 'InputGroup'">
    <input
      [id]="id()"
      [attr.data-cy]="id()"
      [style]="maxWidth() ? 'max-width: ' + maxWidth() : ''"
      type="text"
      class="form-control"
      [class.ng-invalid]="invalid() === true"
      [inputMask]="dateInputMask"
      [formControl]="formControl"
      placeholder="dd.mm.yyyy" />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" (click)="dp.toggle()">
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </div>
  <span [hidden]="hideSubtitle()" class="small text-muted">{{ 'date_control.date_format' | translate }}</span>
  @if (showCustomButtons()) {
    <div class="mt-1">
      <button nkButton class="me-1" color="secondary" [size]="size() ? size() : undefined" (click)="setToday()">
        {{ 'date_control.today' | translate }}
      </button>
      <button nkButton class="me-1" color="secondary" [size]="size() ? size() : undefined" (click)="setNever()">
        {{ 'date_control.never' | translate }}
      </button>
    </div>
  }
  <input
    type="text"
    class="hidden-datepicker position-absolute w-100"
    [formControl]="bsDatepickerFormControl"
    #dp="bsDatepicker"
    bsDatepicker
    container="nk-date-control"
    [bsConfig]="{ adaptivePosition: true }"
    triggers="focusin" />
  <ng-content></ng-content>
</div>
